import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Snackbar, Alert } from '@mui/material';
import { requestNotificationPermission, subscribeUserToPush } from '../utils/pushNotifications';

const Dashboard: React.FC = () => {
  const [pushStatus, setPushStatus] = useState<string | null>(null);
  const [snack, setSnack] = useState<{ open: boolean; message: string; severity: 'info' | 'success' | 'warning' | 'error' }>({ open: false, message: '', severity: 'info' });

  useEffect(() => {
    if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
      setPushStatus('enabled');
    }
  }, []);

  const handleEnableNotifications = async () => {
    const permission = await requestNotificationPermission();
    if (permission === 'unsupported') {
      setSnack({ open: true, message: 'Notifications not supported', severity: 'warning' });
      return;
    }
    if (permission === 'denied') {
      setSnack({ open: true, message: 'Notifications blocked. Enable in browser settings.', severity: 'warning' });
      return;
    }
    const result = await subscribeUserToPush();
    if (result.success) {
      setPushStatus('enabled');
      setSnack({ open: true, message: 'Notifications enabled. You’ll get alerts for dispersals.', severity: 'success' });
    } else {
      setSnack({ open: true, message: result.message || 'Could not enable notifications', severity: 'error' });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" component="h1" fontWeight={600} sx={{ mb: 2 }}>
        Home
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
        Welcome. Use the menu below to view students and dispersal requests.
      </Typography>
      {pushStatus !== 'enabled' && (
        <Button variant="outlined" onClick={handleEnableNotifications} sx={{ mb: 2 }}>
          Enable push notifications
        </Button>
      )}
      <Snackbar open={snack.open} autoHideDuration={6000} onClose={() => setSnack((s) => ({ ...s, open: false }))}>
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default Dashboard;
